export default __webpack_public_path__ + "static/media/img14.5e9cf359.png";